import { render, staticRenderFns } from "./SendRequestHistoriesTab.vue?vue&type=template&id=efc73888&scoped=true&lang=pug"
import script from "./SendRequestHistoriesTab.vue?vue&type=script&lang=ts"
export * from "./SendRequestHistoriesTab.vue?vue&type=script&lang=ts"
import style0 from "./SendRequestHistoriesTab.vue?vue&type=style&index=0&id=efc73888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc73888",
  null
  
)

export default component.exports